import { render, staticRenderFns } from "./DrawerAmonestacion.vue?vue&type=template&id=8b6c8792&"
import script from "./DrawerAmonestacion.vue?vue&type=script&lang=js&"
export * from "./DrawerAmonestacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports